import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_EVENTS } from "../../Components/Calendar/event-utils";

const initialState = {
  events: JSON.parse(localStorage.getItem("events")) || [],
  initialEvents: INITIAL_EVENTS,
};

export const eventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    loadEvents: (state, action) => {
      state.events = action.payload;
    },
    addEvent: (state, action) => {
      state.events.push(action.payload);
      localStorage.setItem("events", JSON.stringify(state.events));
    },
    deleteEvent: (state, action) => {
      state.events = state.events.filter(
        (event) => event.id !== action.payload
      );
      localStorage.setItem("events", JSON.stringify(state.events));
    },
    updateEvent: (state, action) => {
      state.events = state.events.map((event) =>
        event.id === action.payload.id
          ? { ...event, title: action.payload.title }
          : event
      );
      localStorage.setItem("events", JSON.stringify(state.events));
    },
  },
});

export const { loadEvents, addEvent, deleteEvent, updateEvent } =
  eventSlice.actions;
export default eventSlice.reducer;
